import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PortfolioService} from "../../portfolio/portfolio.service";
import {ColumnType} from "../../../components/cim-datatable/cim-datatable.component";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import { MaterialModule } from 'src/app/app.materials';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface WeightColumn {
  id: string;
  label: string;
  type: number;
  textRight?: boolean;
  suffix?: string;
}

@Component({
  selector: 'app-optimized-portfolio-weights',
  templateUrl: './optimized-portfolio-weights.component.html',
  styleUrls: ['./optimized-portfolio-weights.component.scss'],
  standalone: true,
  imports: [MaterialModule, DecimalPipe, CommonModule, FormsModule]
})
export class OptimizedPortfolioWeightsComponent implements OnInit {

  @Input() filteredOptimWeights: any[] = [];
  @Input() savedModifiedWeights: any[] = [];
  @Input() portfolioID: number = null;

  @Output() onWeightsSaved: EventEmitter<any> = new EventEmitter<any>();
  typeList = [];

  columnLabels: string[] = [];
  dataSource = new MatTableDataSource<any>();

  optimizedPortfolioWeightsColumns: WeightColumn[] = [
    {id: 'company_name', label: 'Asset', type: ColumnType.CompanyInfo},
    {id: 'Ticker', label: 'Ticker', type: ColumnType.Simple},
    {id: 'minimum_variance_portfolio', label: 'Minimum Variance Portfolio', type: ColumnType.Percentage},
    {id: 'efficient_portfolio_max_mu', label: 'Efficient Portfolio Max Return', type: ColumnType.Percentage},
    {id: 'efficient_portfolio_max_sharpe_ratio', label: 'Efficient Portfolio Max Sharpe', type: ColumnType.Percentage},
    {id: 'efficient_portfolio_given_mu', label: 'Efficient Portfolio Target Return', type: ColumnType.Percentage},
    {id: 'efficient_portfolio_given_sigma', label: 'Efficient Portfolio Target Volatility', type: ColumnType.Percentage},
    {id: 'my_portfolio', label: '', type: 99},
  ];

  selectList = [
    {id: 'minimum_variance_portfolio', label: 'Minimum Variance Portfolio'},
    {id: 'efficient_portfolio_max_mu', label: 'Efficient Portfolio Max Return'},
    {id: 'efficient_portfolio_max_sharpe_ratio', label: 'Efficient Portfolio Max Sharpe'},
    {id: 'efficient_portfolio_given_mu', label: 'Efficient Portfolio Target Return'},
    {id: 'efficient_portfolio_given_sigma', label: 'Efficient Portfolio Target Volatility'},
  ];

  selectedType: string = null;
  selectedTypeID: string = null;

  totalWeight: number = null;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(
    private service: PortfolioService
  ) { }

  ngOnInit(): void {
    this.initSavedWeights();
    this.typeList = this.service.typeList;
    this.initTable();
  }

  initSavedWeights() {
    if (this.savedModifiedWeights && this.savedModifiedWeights.length) {
      this.selectedTypeID = this.savedModifiedWeights[0].source;
      this.selectedType = this.selectList.filter(f => f.id == this.selectedTypeID)[0].label;

      this.filteredOptimWeights = this.filteredOptimWeights.map(f => {
        this.savedModifiedWeights.map(s => {
          if (f.Ticker == s.ticker) {
            f.my_portfolio = (s.weight * 100).toFixed(2);
          }
        });
        return f;
      });
    }
  }

  onSelectChange(type) {
    this.selectedTypeID = type;
    this.filteredOptimWeights = this.filteredOptimWeights.map(w => {
      w.my_portfolio = (w[type] * 100).toFixed(2);
      return w;
    });
  }

  initTable() {
    this.columnLabels = this.optimizedPortfolioWeightsColumns.map(c => c.id);
    this.dataSource = new MatTableDataSource(this.filteredOptimWeights);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  onCompanyInfoClick(company) {
    this.service.openCompanyInfoDialog(company.Ticker)
  }

  saveWeights() {
    const weights = this.filteredOptimWeights.map(w => {
      return {
        weight: +w.my_portfolio / 100,
        ticker: w.Ticker,
        source: this.selectedTypeID
      };
    });
    this.service.saveModifiedOptimWeights(this.portfolioID, {data: weights}).subscribe(resp => {
      this.service.notificationService.open("Weights saved, computation started");
      this.onWeightsSaved.emit();
    });
  }

  checkWeights() {
    this.totalWeight = 0;
    this.filteredOptimWeights.map(f => {
      this.totalWeight += +f.my_portfolio;
    });
    this.totalWeight = +this.totalWeight.toFixed(2);
  }
}
